(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["botani-article"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-botani-copy]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-botani-copy');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var prev = btn.textContent;
        btn.textContent = '✓';
        setTimeout(function () { btn.textContent = prev; }, 1400);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botani-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initBanner(root) {
      if (!root || root.dataset.bannerBound === '1') return;
      root.dataset.bannerBound = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.botani-banner__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-banner-dot]'));
      var n = slides.length;
      if (n < 2) return;
      var current = 0, timer = null;
      var rotate = root.getAttribute('data-rotate') === '1' && !REDUCE;
      var duration = (parseInt(root.getAttribute('data-duration'), 10) || 5) * 1000;

      function show(i) {
        current = (i % n + n) % n;
        slides.forEach(function (sl, idx) {
          var on = idx === current;
          sl.classList.toggle('is-active', on);
          sl.setAttribute('aria-hidden', on ? 'false' : 'true');
          var link = sl.querySelector('.botani-banner__link');
          if (link) link.setAttribute('tabindex', on ? '0' : '-1');
        });
        dots.forEach(function (d, idx) {
          var on = idx === current;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
      function next() { show(current + 1); }
      function prev() { show(current - 1); }
      function start() { if (rotate && !timer) timer = setInterval(next, duration); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      var pn = root.querySelector('[data-banner-prev]');
      var nx = root.querySelector('[data-banner-next]');
      if (pn) pn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); prev(); restart(); });
      if (nx) nx.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); next(); restart(); });
      dots.forEach(function (d, idx) { d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx); restart(); }); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); restart(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); next(); restart(); }
      });

      var vp = root.querySelector('.botani-banner__viewport');
      var x0 = null;
      vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
        x0 = null; start();
      }, { passive: true });

      // Exposed for the theme-editor handlers below.
      root._bannerShow = show;
      root._bannerStop = stop;
      root._bannerStart = start;
      show(0);
      start();
    }

    function initAll() { document.querySelectorAll('[data-banner]').forEach(initBanner); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    // Theme editor lifecycle.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-banner]');
      if (root) { root.dataset.bannerBound = ''; initBanner(root); }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-banner]');
      if (root && typeof root._bannerStop === 'function') root._bannerStop(); // kill orphan timer
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-banner]');
      var slide = e.target.closest('.botani-banner__slide');
      if (root && typeof root._bannerStop === 'function') root._bannerStop();
      if (root && slide && typeof root._bannerShow === 'function') root._bannerShow(parseInt(slide.getAttribute('data-slide'), 10) || 0);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('[data-banner]');
      if (root && typeof root._bannerStart === 'function') root._bannerStart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botani-capture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var overlay = document.getElementById('BotaniCapOverlay');
    if (!overlay) return;
    var pop = overlay.querySelector('.bcap-pop');
    var formWrap = document.getElementById('BotaniCapForm');
    var success = document.getElementById('BotaniCapSuccess');
    var form = document.getElementById('BotaniCaptureForm');
    var errEl = document.getElementById('BotaniCapError');
    var tab = document.querySelector('.bcap-tab');
    var DONE = 'botani_capture_done', DISMISS = 'botani_capture_dismissed';

    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function isDone() { return get(DONE) === '1'; }
    function isDismissed() { var v = get(DISMISS); if (!v) return false; var t = parseInt(v, 10); return t ? Date.now() < t : true; }

    function focusables() {
      return Array.prototype.filter.call(
        pop.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; });
    }
    var lastFocus = null;
    function open() {
      if (overlay.classList.contains('open')) return;
      lastFocus = document.activeElement;
      overlay.classList.add('open'); overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var f = focusables()[0]; if (f) f.focus();
      document.addEventListener('keydown', onKey, true);
    }
    function close(dismiss) {
      overlay.classList.remove('open'); overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey, true);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      if (dismiss && !isDone()) set(DISMISS, String(Date.now() + 30 * 24 * 60 * 60 * 1000));
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function hideTab() { if (tab) tab.style.display = 'none'; }
    function showSuccess() {
      if (formWrap) formWrap.style.display = 'none';
      if (success) success.classList.add('show');
      set(DONE, '1');
      hideTab(); // once the code is captured, the tab is gone for good on this device
      var g = success && success.querySelector('.bcap-go'); if (g) g.focus();
    }
    // Already captured on this device -> never show the tab (or auto-open) again.
    if (isDone()) hideTab();
    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }

    var autoOpened = false;
    function autoOpen() { if (autoOpened || isDone() || isDismissed()) return; autoOpened = true; open(); }

    document.addEventListener('click', function (e) {
      var t = e.target.nodeType === 1 ? e.target : e.target.parentElement;
      if (!t) return;
      if (t.closest('[data-botani-cap-open]')) { e.preventDefault(); open(); return; }
      if (t.closest('[data-botani-cap-close]')) { e.preventDefault(); close(true); return; }
      if (e.target === overlay) close(true);
    });

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (!isMobile && overlay.getAttribute('data-exit-intent') === 'true') {
      document.addEventListener('mouseout', function (e) { if (e.clientY <= 0 && !e.relatedTarget) autoOpen(); });
    }
    if (isMobile) {
      var delay = parseInt(overlay.getAttribute('data-mobile-delay'), 10); if (!delay || delay < 0) delay = 20;
      setTimeout(autoOpen, delay * 1000);
    }

    var submitBtn = form ? form.querySelector('.bcap-submit') : null;
    function submitCapture() {
      var email = document.getElementById('BotaniCapEmail'), consent = document.getElementById('BotaniCapConsent');
      var phone = document.getElementById('BotaniCapPhone'), tags = document.getElementById('BotaniCapTags');
      var wrap = document.getElementById('BotaniCapConsentWrap'), ok = true;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (!email.value.trim() || email.value.indexOf('@') < 1) { email.classList.add('bcap-err'); ok = false; } else email.classList.remove('bcap-err');
      if (!consent.checked) { if (wrap) wrap.classList.add('bcap-err'); ok = false; } else if (wrap) wrap.classList.remove('bcap-err');
      if (!ok) return;
      // Tag SMS intent only when a phone is given AND consent is ticked. NOTE: the
      // store's SMS app must run the double opt-in confirmation for RGPD compliance
      // — capturing the number here is not consent on its own, not the theme's job.
      var t = 'botani-popup';
      if (phone && phone.value.trim()) t += ', sms-optin';
      if (tags) tags.value = t;
      if (submitBtn) submitBtn.disabled = true;
      // Error ONLY if Shopify re-rendered form.errors inline; otherwise success.
      // (The dev preview returns an opaque 401/redirect for the POST even though the
      // contact is saved — never a false negative, still surfaces real rejections.)
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var srvErr = doc.querySelector('.bcap-formerr');
          var msg = srvErr ? srvErr.textContent.replace(/\s+/g, ' ').trim() : '';
          if (msg) showError(msg); else showSuccess();
        })
        .catch(function () { showError('Connexion impossible pour le moment. Réessaie dans un instant.'); })
        .then(function () { if (submitBtn) submitBtn.disabled = false; });
    }
    if (form && submitBtn) {
      submitBtn.addEventListener('click', function (e) { e.preventDefault(); submitCapture(); });
      // Enter in a field submits via JS too (the form never submits natively -> no reload).
      form.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitCapture(); } });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botani-cashback"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.bcb-faqitem').forEach(function (item) {
        if (item.dataset.bcbBound) return;
        item.dataset.bcbBound = '1';
        var summary = item.querySelector('.bcb-faqq');
        if (!summary) return;
        summary.addEventListener('click', function () {
          var wasOpen = item.hasAttribute('open');
          var list = item.closest('.bcb-faqlist');
          if (list) list.querySelectorAll('.bcb-faqitem[open]').forEach(function (o) { if (o !== item) o.removeAttribute('open'); });
        });
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botani-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DURATION = 300;

    function bind(item) {
      if (item.dataset.botaniFaqBound) return;
      item.dataset.botaniFaqBound = '1';

      var summary = item.querySelector('.botani-faq__q');
      var panel = item.querySelector('.botani-faq__a');
      if (!summary || !panel) return;

      summary.addEventListener('click', function (event) {
        // No animation requested -> let native <details> behave.
        if (REDUCE) return;

        event.preventDefault();
        if (item.dataset.animating === '1') return;
        item.dataset.animating = '1';

        var opening = !item.hasAttribute('open');
        var target;

        function cleanup() {
          panel.classList.remove('is-animating');
          panel.style.height = '';
          panel.style.opacity = '';
          item.dataset.animating = '';
          panel.removeEventListener('transitionend', onEnd);
        }
        function onEnd(e) {
          if (e.propertyName !== 'height') return;
          if (!opening) item.removeAttribute('open');
          cleanup();
        }

        if (opening) {
          item.setAttribute('open', '');
          target = panel.scrollHeight;
          panel.style.height = '0px';
          panel.style.opacity = '0';
          // force reflow so the start values are committed
          void panel.offsetHeight;
          panel.classList.add('is-animating');
          panel.style.height = target + 'px';
          panel.style.opacity = '1';
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.style.opacity = '1';
          void panel.offsetHeight;
          panel.classList.add('is-animating');
          panel.style.height = '0px';
          panel.style.opacity = '0';
        }

        panel.addEventListener('transitionend', onEnd);
        // Safety fallback if transitionend doesn't fire
        setTimeout(function () {
          if (item.dataset.animating === '1') {
            if (!opening) item.removeAttribute('open');
            cleanup();
          }
        }, DURATION + 80);
      });
    }

    function init() {
      document.querySelectorAll('.botani-faq__item').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Re-bind in the theme editor when a section is re-rendered
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botani-hours"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function toMin(t) {
      if (!t) return null;
      var p = String(t).split(':');
      var h = parseInt(p[0], 10);
      if (isNaN(h)) return null;
      var m = parseInt(p[1] || '0', 10);
      return h * 60 + (isNaN(m) ? 0 : m);
    }
    function dayLabel(row) {
      return (row.getAttribute('data-label') || '').trim();
    }
    function findNext(map, day, curMin) {
      for (var i = 0; i <= 7; i++) {
        var d = (day + i) % 7;
        var r = map[d];
        if (!r || r.getAttribute('data-closed') === '1') continue;
        var o = toMin(r.getAttribute('data-open'));
        if (o == null) continue;
        var t = r.getAttribute('data-open');
        if (i === 0) { if (curMin < o) return 'ouvre à ' + t; else continue; }
        if (i === 1) return 'ouvre demain à ' + t;
        return 'ouvre ' + dayLabel(r).toLowerCase() + ' à ' + t;
      }
      return '';
    }
    function init() {
      var table = document.getElementById('BotaniHoursTable');
      var card = document.getElementById('BotaniHoursStatus');
      if (!table || !card || card.dataset.bhBound) return;
      card.dataset.bhBound = '1';

      var rows = Array.prototype.slice.call(table.querySelectorAll('.bhours-row'));
      if (!rows.length) return;
      var now = new Date();
      var day = now.getDay();
      var curMin = now.getHours() * 60 + now.getMinutes();
      var soon = parseInt(table.getAttribute('data-close-soon'), 10) || 30;
      var openLabel = card.getAttribute('data-open-label') || 'Ouvert';
      var closedLabel = card.getAttribute('data-closed-label') || 'Fermé';

      var map = {}, todayRow = null;
      rows.forEach(function (r) {
        var wd = parseInt(r.getAttribute('data-weekday'), 10);
        map[wd] = r;
        if (wd === day) todayRow = r;
      });

      if (todayRow) {
        todayRow.classList.add('today');
        var dEl = todayRow.querySelector('.bhours-day');
        if (dEl && !dEl.querySelector('.bhours-badge')) {
          var b = document.createElement('span');
          b.className = 'bhours-badge';
          b.textContent = 'AUJOURD’HUI';
          dEl.appendChild(b);
        }
      }

      var isOpen = false, sub = '';
      if (todayRow && todayRow.getAttribute('data-closed') !== '1') {
        var o = toMin(todayRow.getAttribute('data-open'));
        var c = toMin(todayRow.getAttribute('data-close'));
        if (o != null && c != null) {
          if (curMin < o) { sub = 'Ouvre à <b>' + todayRow.getAttribute('data-open') + '</b>'; }
          else if (curMin < c) {
            isOpen = true;
            if (c - curMin <= soon) sub = 'Ferme bientôt — à <b>' + todayRow.getAttribute('data-close') + '</b>';
            else sub = 'Ouvert jusqu’à <b>' + todayRow.getAttribute('data-close') + '</b>';
          } else { sub = 'Fermé pour aujourd’hui'; }
        }
      } else {
        sub = 'Fermé aujourd’hui';
      }
      if (!isOpen) {
        var nx = findNext(map, day, curMin);
        if (nx) sub += ' · ' + nx;
      }

      card.classList.add(isOpen ? 'is-open' : 'is-closed');
      var lab = document.getElementById('BotaniHoursLabel');
      var subEl = document.getElementById('BotaniHoursSub');
      var nowEl = document.getElementById('BotaniHoursNow');
      if (lab) lab.textContent = isOpen ? openLabel : closedLabel;
      if (subEl) subEl.innerHTML = sub;
      if (nowEl) {
        var dateStr = now.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
        dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
        nowEl.textContent = dateStr + ' · ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botani-main-product"]) return;
  try {
    
  (function () {
    /* Gallery: swipe carousel on mobile/tablet (≤1024px, native scroll-snap),
       single-image + thumbnail switch on desktop (>1024px). Dots + thumbnails
       stay synchronised with the active slide in both directions. */
    function initGallery() {
      var slides = document.getElementById('BotaniGallerySlides');
      if (!slides || slides.dataset.bound) return;
      var slideEls = slides.querySelectorAll('.bp-gslide');
      if (slideEls.length < 2) return; // single image: nothing to wire
      slides.dataset.bound = '1';
      var thumbs = document.querySelectorAll('.bp-gthumb');
      var dots = document.querySelectorAll('.bp-gdot');
      var desktop = window.matchMedia('(min-width: 1025px)');

      function setActive(i) {
        for (var s = 0; s < slideEls.length; s++) slideEls[s].classList.toggle('is-active', s === i);
        for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === i);
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      }
      function goTo(i, smooth) {
        // mobile/tablet: scroll the snap track; desktop: just toggle visibility
        if (!desktop.matches) {
          slides.scrollTo({ left: i * slides.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
        }
        setActive(i);
      }

      // thumbnail tap → main image follows (both modes)
      for (var ti = 0; ti < thumbs.length; ti++) {
        (function (i) { thumbs[i].addEventListener('click', function () { goTo(i, true); }); })(ti);
      }
      // dot tap → scroll to that slide
      for (var di = 0; di < dots.length; di++) {
        (function (i) { dots[i].addEventListener('click', function () { goTo(i, true); }); })(di);
      }
      // swipe → update dots/thumbnails from the snapped slide (mobile/tablet)
      var raf;
      slides.addEventListener('scroll', function () {
        if (desktop.matches) return;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = slides.clientWidth || 1;
          setActive(Math.round(slides.scrollLeft / w));
        });
      }, { passive: true });

      setActive(0);
    }

    function fmtEUR(value) {
      try {
        return value.toLocaleString('fr-FR', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' });
      } catch (e) { return value.toFixed(2).replace('.', ',') + ' €'; }
    }

    // Cashback (display only): re-queries the box each call so it stays correct after
    // shopify:section:load. baseCents = the currently selected price in CENTS (g×ppg for
    // grammage, qty×unit for accessory). Floored to the cent (never rounded up).
    function updateCashback(baseCents) {
      var box = document.getElementById('BotaniCashback');
      if (!box) return;
      var rate = parseFloat(box.getAttribute('data-rate')) || 0;
      var amount = Math.floor((baseCents * rate) / 100);
      if (amount <= 0) { box.hidden = true; return; }
      var amtEl = document.getElementById('BotaniCashbackAmount');
      if (amtEl) amtEl.textContent = fmtEUR(amount / 100);
      box.hidden = false;
    }

    // Resolve the add quantity from MY selector — never from Kaching.
    // Grammage mode: the SELECTED gram button (.bp-gram.is-sel) is the source of
    // truth (Kaching can't pollute it). Accessory mode / fallback: #BotaniQty.
    function currentQty(form) {
      var selGram = form.querySelector('.bp-gram.is-sel') || document.querySelector('.bp-gram.is-sel');
      if (selGram) return parseInt(selGram.getAttribute('data-grams'), 10) || 1;
      var qtyInput = document.getElementById('BotaniQty');
      return parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
    }

    // Add to cart → unified through window.BotaniCart (botani-cart.js).
    // Retries briefly if BotaniCart isn't ready yet; NEVER lets the native form
    // submit (which would navigate to /cart). The drawer is the only path.
    function triggerAdd(form) {
      if (!form || form.dataset.adding === '1') return;
      form.dataset.adding = '1';
      var addBtns = [form.querySelector('.bp-add'), document.querySelector('.bp-sticky__btn')];
      addBtns.forEach(function (b) { if (b) b.classList.add('loading'); });
      var idField = form.querySelector('[name="id"]');
      var variantId = idField ? idField.value : null;
      var qty = currentQty(form);
      function done() { form.dataset.adding = ''; addBtns.forEach(function (b) { if (b) b.classList.remove('loading'); }); }
      if (!variantId) { done(); return; }

      var tries = 0;
      (function go() {
        if (window.BotaniCart && typeof window.BotaniCart.add === 'function') {
          Promise.resolve(window.BotaniCart.add(variantId, qty)).then(done, done);
        } else if (tries++ < 60) {
          setTimeout(go, 50); // wait for botani-cart.js (deferred) — up to ~3s
        } else {
          done(); // give up silently; we still never navigated to /cart
        }
      })();
    }

    // CAPTURE-phase interceptors on document: they fire BEFORE any listener the
    // Kaching app attaches (capture or bubble) on the button/form, so Kaching can
    // never hijack the add or force its own quantity. We preventDefault FIRST and
    // UNCONDITIONALLY so the form can never submit natively to /cart, then drive
    // the add ourselves through the drawer.
    function bindSubmit() {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.bp-add, .bp-sticky__btn') : null;
        if (!btn) return;
        // Always use OUR form by id — Kaching may wrap the button in its own
        // <form>, so btn.form would point to the wrong one. #BotaniProductForm
        // holds our [name=id] + grammage cards.
        var form = document.getElementById('BotaniProductForm') || btn.form;
        if (!form) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        triggerAdd(form);
      }, true);

      // Enter key (submits without a button click)
      document.addEventListener('submit', function (e) {
        if (!e.target || e.target.id !== 'BotaniProductForm') return;
        e.preventDefault();
        e.stopImmediatePropagation();
        triggerAdd(e.target);
      }, true);
    }

    /* GRAMMAGE mode (flowers/resins) — quantity = grams, indicative price */
    function initGrammage(form) {
      var wrap = document.getElementById('BotaniGrammage');
      if (!wrap) return;
      var qtyInput = document.getElementById('BotaniQty');
      var totalEl = document.getElementById('BotaniTotal');
      var stickyEl = document.getElementById('BotaniStickyPrice');
      var grams = wrap.querySelectorAll('.bp-gram');

      /* Économies (affichage seul) : dérivé des boutons .bp-gram, aucun appel panier. */
      var savingsBox = document.getElementById('BotaniSavings');
      var ARROW_UP = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7M9 7h8v8"/></svg>';
      var CHECK_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5l10 -10"/></svg>';
      function updateSavings(q, ppg) {
        if (!savingsBox) return;
        var tiers = Array.prototype.map.call(grams, function (b) {
          return {
            g: parseInt(b.getAttribute('data-grams'), 10) || 0,
            ppg: parseFloat(b.getAttribute('data-ppg')) || 0,
            disabled: !!b.disabled
          };
        }).filter(function (t) { return t.g > 0 && t.ppg > 0; });
        tiers.sort(function (a, b) { return a.g - b.g; });
        if (tiers.length < 2) { savingsBox.hidden = true; return; }

        var base = tiers[0].ppg;                  // prix du premier palier
        var top = tiers[tiers.length - 1];        // plus gros palier
        var maxEco = top.g * (base - top.ppg);    // économie maximale possible
        if (maxEco <= 0) { savingsBox.hidden = true; return; }

        var curEco = q * (base - ppg);            // économie sur le palier courant
        if (curEco < 0) curEco = 0;
        var pct = Math.max(0, Math.min(100, Math.round(curEco / maxEco * 100)));

        // prochain palier atteignable (grammage supérieur, non désactivé)
        var next = null;
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i].g > q && !tiers[i].disabled) { next = tiers[i]; break; }
        }

        var nowEl = document.getElementById('BotaniSavingsNow');
        var maxEl = document.getElementById('BotaniSavingsMax');
        var bar = document.getElementById('BotaniSavingsBar');
        var fill = document.getElementById('BotaniSavingsFill');
        var foot = document.getElementById('BotaniSavingsFoot');
        if (nowEl) nowEl.textContent = fmtEUR(curEco);
        if (maxEl) maxEl.textContent = fmtEUR(maxEco);
        if (fill) fill.style.width = pct + '%';
        if (bar) bar.setAttribute('aria-valuenow', pct);

        if (foot) {
          if (next) {
            var extra = (next.g * (base - next.ppg)) - curEco;
            if (extra < 0) extra = 0;
            foot.className = 'bp-savings__foot bp-savings__next';
            foot.innerHTML = ARROW_UP + '<span>Passe à ' + next.g + 'g : tu économises ' + fmtEUR(extra) + ' de plus, soit ' + fmtEUR(next.ppg) + '/g.</span>';
          } else {
            foot.className = 'bp-savings__foot bp-savings__best';
            foot.innerHTML = CHECK_ICON + '<span>Tu es au meilleur prix, ' + fmtEUR(ppg) + '/g.</span>';
          }
        }
        savingsBox.hidden = false;
      }

      // Each card's BIG label must always show its own grammage (from
      // data-grams). The Kaching app injects its default bundle TOTAL into the
      // first tier card (e.g. "55,00 €"), so we re-assert the grams text and
      // watch for any external overwrite, restoring it. Guarded flag prevents
      // our own write from re-triggering the observer (no loop).
      var paintingGrams = false;
      function paintGrams() {
        paintingGrams = true;
        grams.forEach(function (btn) {
          var g = parseInt(btn.getAttribute('data-grams'), 10) || 1;
          var b = btn.querySelector('b');
          var want = g + 'g';
          if (b && b.textContent !== want) b.textContent = want;
        });
        setTimeout(function () { paintingGrams = false; }, 0);
      }
      paintGrams();
      if (window.MutationObserver) {
        var gobs = new MutationObserver(function () {
          if (paintingGrams) return;
          paintGrams();
        });
        gobs.observe(wrap, { childList: true, subtree: true, characterData: true });
      }

      function select(btn) {
        if (!btn || btn.disabled) return;
        grams.forEach(function (g) { g.classList.remove('is-sel'); });
        btn.classList.add('is-sel');
        var q = parseInt(btn.getAttribute('data-grams'), 10) || 1;
        var ppg = parseFloat(btn.getAttribute('data-ppg')) || 0;
        if (qtyInput) qtyInput.value = q;
        // Display: exact total to the cent (q grams × ppg), so real cents like
        // 8,25 €/g show their value (1g -> "8,25 €"). BUT snap to the whole euro
        // when the total lands within a few cents of it, to hide ppg-rounding
        // artifacts (e.g. 3g × 11,67 = 35,01 € -> "35,00 €"). Genuine fractions
        // like ,25 / ,50 / ,75 are kept. Real charged price handled by Kaching.
        var cents = Math.round(q * ppg * 100);
        var rem = cents % 100;
        if (rem <= 3 || rem >= 97) {
          cents = Math.round(cents / 100) * 100;
        }
        var indicative = fmtEUR(cents / 100);
        if (totalEl) totalEl.textContent = indicative;
        if (stickyEl) stickyEl.textContent = indicative;
        updateSavings(q, ppg);
        updateCashback(q * ppg * 100);
      }
      grams.forEach(function (btn) { btn.addEventListener('click', function () { select(btn); }); });
      var firstEnabled = wrap.querySelector('.bp-gram:not(:disabled)');
      if (firstEnabled) select(firstEnabled);
    }

    /* ACCESSORY mode — quantity = units, real price (qty × variant price) */
    function initAccessory(form) {
      var qtyInput = document.getElementById('BotaniQty');
      var qtyDisplay = document.getElementById('BotaniQtyDisplay');
      var totalEl = document.getElementById('BotaniTotal');
      var stickyEl = document.getElementById('BotaniStickyPrice');
      var priceNow = document.getElementById('BotaniPriceNow');
      var sel = document.getElementById('BotaniVariantSelect');
      var stockEl = document.getElementById('BotaniStock');
      var minus = form.querySelector('[data-qty-minus]');
      var plus = form.querySelector('[data-qty-plus]');

      function truthy(v) { return v === '1' || v === 'true'; }
      function unitInfo() {
        if (sel && sel.options.length) {
          var opt = sel.options[sel.selectedIndex];
          return {
            price: parseInt(opt.getAttribute('data-price'), 10) || 0,
            stock: parseInt(opt.getAttribute('data-stock'), 10),
            limited: truthy(opt.getAttribute('data-tracked'))
          };
        }
        return {
          price: parseInt(form.getAttribute('data-unit-price'), 10) || 0,
          stock: parseInt(form.getAttribute('data-stock'), 10),
          limited: truthy(form.getAttribute('data-limited'))
        };
      }

      // Badge stock en direct — reflète la variante sélectionnée en reprenant
      // les 3 états du rendu serveur (épuisé / faible / en stock), le même seuil
      // (data-low) et les mêmes libellés, pour rester cohérent à chaque changement.
      var SVG_OUT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0M9 9l6 6M15 9l-6 6"/></svg>';
      var SVG_LOW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4M12 16h.01M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"/></svg>';
      var SVG_IN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0M9 12l2 2l4 -4"/></svg>';
      function renderStock(info) {
        if (!stockEl) return;
        var low = parseInt(stockEl.getAttribute('data-low'), 10);
        if (isNaN(low)) low = 0;
        var cls = 'bp-stock';
        var html;
        if (info.limited && info.stock <= 0) {
          // Suivi + 0 en stock : épuisé.
          cls += ' bp-stock--out';
          html = SVG_OUT + (stockEl.getAttribute('data-soldout') || '');
        } else if (info.limited && info.stock <= low) {
          // Suivi + sous le seuil : compte exact.
          cls += ' bp-stock--low';
          html = SVG_LOW + 'Plus que ' + info.stock + ' ' + (info.stock > 1 ? 'unités' : 'unité');
        } else {
          // Non suivi, illimité, ou au-dessus du seuil : en stock, sans chiffre.
          html = SVG_IN + (stockEl.getAttribute('data-instock') || '');
        }
        stockEl.className = cls;
        stockEl.innerHTML = html;
      }

      function render() {
        var info = unitInfo();
        var q = parseInt(qtyDisplay ? qtyDisplay.value : '1', 10);
        if (isNaN(q) || q < 1) q = 1;
        if (info.limited && !isNaN(info.stock) && info.stock > 0 && q > info.stock) q = info.stock;
        if (qtyDisplay) qtyDisplay.value = q;
        if (qtyInput) qtyInput.value = q;
        var total = q * info.price;
        if (totalEl) totalEl.textContent = fmtEUR(total / 100);
        if (stickyEl) stickyEl.textContent = fmtEUR(total / 100);
        if (priceNow) priceNow.textContent = fmtEUR(info.price / 100);
        renderStock(info);
        updateCashback(total);
      }

      if (minus) minus.addEventListener('click', function () {
        var q = parseInt(qtyDisplay.value, 10) || 1; qtyDisplay.value = Math.max(1, q - 1); render();
      });
      if (plus) plus.addEventListener('click', function () {
        var q = parseInt(qtyDisplay.value, 10) || 1; qtyDisplay.value = q + 1; render();
      });
      if (qtyDisplay) qtyDisplay.addEventListener('input', function () {
        qtyDisplay.value = qtyDisplay.value.replace(/[^0-9]/g, ''); render();
      });
      if (sel) sel.addEventListener('change', render);
      render();
    }

    function init() {
      initGallery();
      var form = document.getElementById('BotaniProductForm');
      if (!form || form.dataset.botaniBound) return;
      form.dataset.botaniBound = '1';
      bindSubmit();
      if (form.getAttribute('data-mode') === 'true') initAccessory(form);
      else initGrammage(form);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
